import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9fxzj7m6yk: FaireBrandEntity = {
  token: "b_9fxzj7m6yk",
  type: "brand",
  name: "Good Printed Things",
  avatarUrl: "https://cdn.faire.com/fastly/9b7d0552d50f64941182ddd0f1ccd47b8a6ecccde280263c406802c34fba8039.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/759c10ef6b0beb16ccbd39885cb06a4415c6ba1bdf2a6e90104e4468bd707c71.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/9b7d0552d50f64941182ddd0f1ccd47b8a6ecccde280263c406802c34fba8039.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/759c10ef6b0beb16ccbd39885cb06a4415c6ba1bdf2a6e90104e4468bd707c71.jpeg",
  location: "Greenville, SC, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 12,
  isTopShop: true,
  isInsider: true,
  description: "Hi, my name is Lib Ramos and I run Good Printed Things — an independent publisher of small batch collaborative print projects.\n\nAs a graphic designer, I've spent my career in advertising (in both agencies and as part of internal design teams) and I've been the creative director for a non-profit arts organization for the past fifteen years. Good Printed Things began as a way to facilitate creativity and collaboration between writers, designers, artists, and makers. As an avid reader, I've now fallen in love with the world of independent publishing and the way that creative talents can intersect to create new and beautiful things. \n\nI've always loved analog things and am convinced that tangible objects play an important role in our increasingly digital world. I firmly believe that creative work should take up space and live on the printed page and not just inside our screens.",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:03.160Z",
    importedBy: "entity-db-cli"
  }
};
